// language=GraphQL
export const ALL_FILTER_LEAD_BLOCKS_QUERY = `query Query {
  filterLeadBlocks: cmsFilterLeadBlocks {
    id
    layout
  }
}`

// language=GraphQL
export const SINGLE_FILTER_LEAD_BLOCK_QUERY = `query Query($id: ID!) {
  filterLeadBlock: cmsFilterLeadBlock(id: $id) {
    id
    layout
  }
}`

// language=GraphQL
export const CREATE_FILTER_LEAD_BLOCK_MUTATION = `
  mutation Mutation($input: CreateCmsFilterLeadBlockInput) {
    filterLeadBlock: createCmsFilterLeadBlock(input: $input) {
      id
      layout
    }
  }`

// language=GraphQL
export const UPDATE_FILTER_LEAD_BLOCK_MUTATION = `
  mutation Mutation($input: UpdateCmsFilterLeadBlockInput) {
    filterLeadBlock: updateCmsFilterLeadBlock(input: $input) {
      id
      layout
    }
  }`

// language=GraphQL
export const DELETE_FILTER_LEAD_BLOCK_MUTATION = `
  mutation Mutation($input: DeleteCmsFilterLeadBlockInput) {
    deleteCmsFilterLeadBlock(input: $input) {
      success
    }
  }`

// language=GraphQL
export const FORCE_DELETE_FILTER_LEAD_BLOCK_MUTATION = `
  mutation Mutation($input: DeleteCmsFilterLeadBlockInput) {
    forceDeleteCmsFilterLeadBlock(input: $input) {
      success
    }
  }`
